export enum RelationshipType {
  Mother = 'Mother',
  Father = 'Father',
  Spouse = 'Spouse',
  Son = 'Son',
  Daughter = 'Daughter',
  Grandmother = 'Grandmother',
  Grandfather = 'Grandfather',
  Brother = 'Brother',
  Sister = 'Sister',
  LegalGuardian = 'Legal guardian',
  AdoptiveChild = 'Adoptive child',
  AdoptiveMother = 'Adoptive mother',
  AdoptiveFather = 'Adoptive father',
  VerifiedStepmother = 'Verified stepmother',
  VerifiedStepfather = 'Verified stepfather',
  VerifiedStepsister = 'Verified stepsister',
  VerifiedStepbrother = 'Verified stepbrother'
}
